import { IMessage, IGridPayload, IDocumentPayload } from 'services/interface';

export const VIEW_BILL_DEMO_ACTION = 'local_view_bill_demo';
export const VIEW_BILL_DEMO_GRID_ID_PREFIX = 'view-bill-demo-grid-';
export const VIEW_BILL_DEMO_SHARE_ACTION = 'local_view_bill_demo_share';

export const viewBillDemoGrid: IGridPayload = {
    title: 'Select billing month',
    icon: 'calendar',
    columns: 3,
    selection: 'single',
    items: [
        { label: 'Sep 2025', value: '2025-09' },
        { label: 'Oct 2025', value: '2025-10' },
        { label: 'Nov 2025', value: '2025-11' },
        { label: 'Dec 2025', value: '2025-12' },
        { label: 'Jan 2026', value: '2026-01' },
        { label: 'Feb 2026', value: '2026-02' },
        { label: 'Mar 2026', value: '2026-03' },
        { label: 'Apr 2026', value: '2026-04' },
        { label: 'May 2026', value: '2026-05' },
        { label: 'Jun 2026', value: '2026-06' },
        { label: 'Jul 2026', value: '2026-07' },
        { label: 'Aug 2026', value: '2026-08' }
    ],
    confirm: {
        label: 'View Bill for {label}',
        type: 'submit'
    }
};

const demoBase64 = 'JVBERi0xLjQKMSAwIG9iago8PCAvVHlwZSAvQ2F0YWxvZyAvUGFnZXMgMiAwIFIgPj4KZW5kb2JqCjIgMCBvYmoKPDwgL1R5cGUgL1BhZ2VzIC9LaWRzIFszIDAgUl0gL0NvdW50IDEgPj4KZW5kb2JqCjMgMCBvYmoKPDwgL1R5cGUgL1BhZ2UgL1BhcmVudCAyIDAgUiAvTWVkaWFCb3ggWzAgMCA2MTIgNzkyXSAvQ29udGVudHMgNCAwIFIgL1Jlc291cmNlcyA8PCAvRm9udCA8PCAvRjEgNSAwIFIgPj4gPj4gPj4KZW5kb2JqCjQgMCBvYmoKPDwgL0xlbmd0aCA0NCA+PgpzdHJlYW0KQlQgL0YxIDI0IFRmIDcyIDcyMCBUZCAoTVROIEJpbGwgRGVtbykgVGogRVQKZW5kc3RyZWFtCmVuZG9iago1IDAgb2JqCjw8IC9UeXBlIC9Gb250IC9TdWJ0eXBlIC9UeXBlMSAvQmFzZUZvbnQgL0hlbHZldGljYSA+PgplbmRvYmoKdHJhaWxlcgo8PCAvUm9vdCAxIDAgUiA+PgolJUVPRgo=';

const createDemoDocument = (label: string): IDocumentPayload => ({
    fileName: `MTN-Bill-${label.replace(' ', '-')}.pdf`,
    mimeType: 'application/pdf',
    sizeBytes: 184320,
    url: 'https://auroratts.mtn.ng/bill-pdfs/demo/MTN-Bill-Aug-2026.pdf',
    expiresAt: '2099-09-23T10:45:00.000Z',
    base64: demoBase64,
    details: {
        label,
        billNo: '607004615',
        period: { startDate: '2026-08-01', endDate: '2026-08-31' },
        dueDate: '2026-09-05',
        hasOutstanding: true,
        unpaidAmount: { amount: '8708', unit: 'NGN' },
        totalDueAmount: { amount: '0', unit: 'NGN' }
    }
});

export const createViewBillDemoGridMessage = (): IMessage => ({
    id: `${VIEW_BILL_DEMO_GRID_ID_PREFIX}${Date.now()}`,
    sender: 'agent',
    type: 'grid',
    text: "Which month's bill would you like to view?",
    payload: { grid: viewBillDemoGrid },
    actions: [{ label: 'Cancel', type: 'cancel', action: 'cancel' }]
});

export const createViewBillDemoDocumentMessages = (label: string): IMessage[] => {
    const document = createDemoDocument(label);
    return [
        {
            id: `${VIEW_BILL_DEMO_GRID_ID_PREFIX}caption-${Date.now()}`,
            sender: 'agent',
            type: 'plain',
            text: `Your bill for ${label} is ready`
        },
        {
            id: `${VIEW_BILL_DEMO_GRID_ID_PREFIX}document-${Date.now() + 1}`,
            sender: 'agent',
            type: 'document',
            text: `MTN Postpaid Bill - ${label}`,
            payload: { document },
            actions: [
                { label: 'Pay bill', type: 'submit', action: 'pay_bill' },
                { label: 'Share', type: 'submit', action: VIEW_BILL_DEMO_SHARE_ACTION },
                { label: 'Quit', type: 'cancel', action: 'cancel' }
            ]
        }
    ];
};

export const createViewBillDemoShareMessage = (): IMessage => ({
    id: `${VIEW_BILL_DEMO_SHARE_ACTION}-${Date.now()}`,
    sender: 'agent',
    type: 'plain',
    text: 'How would you like to share your PDF bill?',
    actions: [
        { label: 'WhatsApp', type: 'open_url', action: 'share_whatsapp', icon: 'whatsapp', url: 'https://wa.me/?text=https%3A%2F%2Fauroratts.mtn.ng%2Fbill-pdfs%2Fdemo' },
        { label: 'Messenger', type: 'open_url', action: 'share_messenger', icon: 'messenger', url: 'fb-messenger://share/?link=https%3A%2F%2Fauroratts.mtn.ng%2Fbill-pdfs%2Fdemo' },
        { label: 'Telegram', type: 'open_url', action: 'share_telegram', icon: 'telegram', url: 'https://t.me/share/url?url=https%3A%2F%2Fauroratts.mtn.ng%2Fbill-pdfs%2Fdemo' },
        { label: 'Copy link', type: 'copy_link', action: 'copy_link', icon: 'link', url: 'https://auroratts.mtn.ng/bill-pdfs/demo' },
        { label: 'Quit', type: 'cancel', action: 'cancel' }
    ]
});

